import React, { useEffect, useState } from 'react';
import { api_url } from '../../constant/constant';
import { Card, Form, Spinner, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { showToast } from "../ShowToast/ToastNotification";

const PhishingReports = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const [selectedCampaign, setSelectedCampaign] = useState('');
  const [selectedLanguage, setSelectedLanguage] = useState('1');

  // Fetch Campaigns
  const fetchPhishingCampaigns = async (url = '') => {
    let page = 1;

    if (url !== '') {
      const temp = url.split('?page=');
      page = temp[1] || 1;
    }

    try {
      const token = localStorage.getItem('userToken');
      console.log('Auth Token:', token);

      const response = await fetch(`${api_url}/phishing-campaigns?page=${page}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const result = await response.json();
      setCampaigns(result.data?.data || []);
    } catch (error) {
      console.error('Error fetching Phishing Campaigns:', error);
      setCampaigns([]);
    }
  };

  // Generate Report: Opens PDF in new tab
  const generateReport = async () => {
    if (!selectedCampaign || !selectedLanguage) return;
  
    setLoading(true);
  
    const token = localStorage.getItem("userToken");
  
    try {
      const response = await fetch(
        `${api_url}/reports/phishing/download?campaign_id=${selectedCampaign}&language_id=${selectedLanguage}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );
  
      const data = await response.json();
  
      showToast(data.message, "success");
  
      //  Step 2: Now download the generated report using report_id
      if (data.report_id) {
        handleDownload(data.report_id ,selectedLanguage); //  download function call
      } else {
        showToast("Report ID missing!", "error");
      }
  
    } catch (error) {
      console.log("Generate error:", error);
      showToast("Failed to generate report", "error");
    } finally {
      setLoading(false);
    }
  };
  
  
  const handleDownload = async (id, lang) => {
    console.log('lang',lang);
    try {
      const token = localStorage.getItem("userToken");
  
      const response = await fetch(
        `${api_url}/reports/phishing/get/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
  
      // const link = document.createElement("a");
      // link.href = url;
  
      //  Sirf yahan file type set karo
         // File name
         if(lang == "2"){
          const link = document.createElement("a");
          link.href = url;
          link.download = `phishing-report-${id}.html`;
          link.click();
        }else{
          const link = document.createElement("a");
          link.href = url;
          link.download = `phishing-report-${id}.pdf`;
          link.click();
        }
  
      // document.body.appendChild(link);   // Safari / Firefox fix
      // link.click();
      // document.body.removeChild(link);
  
      window.URL.revokeObjectURL(url);
  
    } catch (error) {
      console.log("Error in file download:", error);
    }
  };
  
  
  useEffect(() => {
    fetchPhishingCampaigns();
  }, []);

  return (
    <div className="container mt-4" style={{ marginBottom: '100px' }}>
      <Card className="shadow-sm rounded">
        <Card.Body>
          <h4 className="mb-4">{t("PhishingReports")}</h4>

          <div className="row align-items-end">
            <div className="col-md-4 mb-3">
              <Form.Group>
                <Form.Label className="fw-semibold">{t("SelectCampaign")}</Form.Label>
                <Form.Select
                  value={selectedCampaign}
                  onChange={(e) => setSelectedCampaign(e.target.value)}
                >
                  <option value="">Select a Campaign</option>
                  {campaigns.map((campaign) => (
                    <option key={campaign.id} value={campaign.id}>
                      {campaign.name || `Campaign #${campaign.id}`}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </div>

            <div className="col-md-4 mb-3">
              <Form.Group>
                <Form.Label className="fw-semibold">{t("SelectLanguage")}</Form.Label>
                <Form.Select
                  value={selectedLanguage}
                  onChange={(e) => setSelectedLanguage(e.target.value)}
                >
                  <option value="1">English</option>
                  <option value="2">Arabic</option>
                </Form.Select>
              </Form.Group>
            </div>
          </div>

          <Button
            variant="primary"
            onClick={generateReport}
            disabled={!selectedCampaign || !selectedLanguage || loading}
          >
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{" "}
                {t("Generating...")}
              </>
            ) : (
              t("GenerateReport/Download")
            )}
          </Button>

        </Card.Body>
      </Card>
    </div>
  );
};

export default PhishingReports;
